import { from, of, timer } from 'rxjs';
import { catchError, map, retryWhen, mergeMap, tap } from 'rxjs/operators';
import * as configcat from 'configcat-js';
import * as i0 from "@angular/core";
import * as i1 from "@imaginelearning/web-api-core";
export class ConfigCatService {
    constructor(environment) {
        this.environment = environment;
        this.baseUrl = this.environment.config.configCatApiUrl;
        this.configCatSdkKey = this.environment.config.configCatSdkKey;
        this.maxRetries = this.environment.config.configCatMaxRetries || 3;
        console.log(`[ConfigCatService]: Initializing ConfigCat client with SDK key: ${this.configCatSdkKey}`);
        // Create the ConfigCat client - AutoPoll handles everything automatically
        this.client = configcat.getClient(this.configCatSdkKey, configcat.PollingMode.AutoPoll, {
            baseUrl: this.baseUrl,
            pollIntervalSeconds: this.environment.config.configCatPollIntervalSeconds || 60,
            requestTimeoutMs: this.environment.config.configCatRequestTimeoutMs || 30000
        });
        // Client is ready immediately after creation
        console.log('[ConfigCatService]: ConfigCat client created and ready.');
    }
    evaluateFlag(flagKey, entityContext) {
        console.log('\n========== ConfigCatService.evaluateFlag START ==========');
        // Check if ConfigCat is enabled and client exists
        if (!this.client) {
            console.warn(`[ConfigCatService]: ConfigCat is disabled, returning false for flag: ${flagKey}`);
            return of(false);
        }
        // Handle empty or undefined entity context
        const context = entityContext || {};
        // Build ConfigCat User object matching dashboard format
        // If none are provided, it will use an empty identifier and rely on flag's default value
        const user = {
            identifier: context.userId || '',
            email: context.email,
            country: context.country,
            custom: {
                role: context.role,
                product: context.product,
                siteCode: context.siteCode
            }
        };
        return from(this.client.getValueAsync(flagKey, false, user)).pipe(map(value => value === true), retryWhen(errors => errors.pipe(mergeMap((error, index) => {
            if (index >= this.maxRetries) {
                throw new Error(`ConfigCat failed after ${this.maxRetries} retries: ${error.message}`);
            }
            const retryDelay = Math.min(1000 * Math.pow(2, index), 5000);
            console.warn(`[ConfigCatService]: Retry attempt ${index + 1} for flag ${flagKey} in ${retryDelay}ms:`, error);
            return timer(retryDelay);
        }))), catchError(error => {
            console.error(`[ConfigCatService]: Error evaluating flag ${flagKey}:`, error);
            return of(false);
        }), tap(result => {
            console.log(`[ConfigCatService]: Flag ${flagKey} evaluated to: ${JSON.stringify(result)}`);
        }));
    }
    ngOnDestroy() {
        if (this.client) {
            console.log('[ConfigCatService]: Disposing ConfigCat client');
            this.client.dispose();
        }
    }
    static { this.ɵfac = function ConfigCatService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ConfigCatService)(i0.ɵɵinject(i1.Environment)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ConfigCatService, factory: ConfigCatService.ɵfac, providedIn: 'root' }); }
}
